export class VoicemodInteractor {
  status = VOICEMOD_DISCONNECTED;
  listener;
  ws;
  promises = [];

  constructor(statusListener) {
    this.listener = statusListener;
  }

  ports = [];
  hosts = [
    'ws://localhost:59129/v1',
    'ws://localhost:20000/v1',
    'ws://localhost:39273/v1',
    'ws://localhost:42152/v1',
    'ws://localhost:43782/v1',
    'ws://localhost:46667/v1',
    'ws://localhost:35679/v1',
    'ws://localhost:37170/v1',
    'ws://localhost:38501/v1',
    'ws://localhost:33952/v1',
    'ws://localhost:30546/v1',
  ];
  currentHostIndex = 0;

  connect() {
    if (this.status === VOICEMOD_DISCONNECTED) {
      this.currentHostIndex = 0;
    }

    if (
      this.status !== VOICEMOD_CONNECTING &&
      this.status !== VOICEMOD_RECONNECTING
    ) {
      this.updateStatus(VOICEMOD_CONNECTING);
    }
    this.ws = new WebSocket(this.hosts[this.currentHostIndex]);
    this.ws.onmessage = this.handleWebsocketMessage;
    this.ws.onopen = this.handleWebsocketOpen;
    this.ws.onclose = this.handleWebsocketClose;
  }

  isConnected() {
    return this.status === VOICEMOD_CONNECTED;
  }

  isConnecting() {
    return this.status === VOICEMOD_CONNECTING;
  }

  getMemes() {
    return this.sendMessage(GetMemes).then((response) => {
      return response.listOfMemes;
    });
  }

  getVoices() {
    return this.sendMessage(CreateGetVoiceMessage).then((response) => {
      return response.voices;
    });
  }

  playMeme(fileName) {
    this.sendMessage(PlayMeme(fileName));
  }

  async playVoice(voiceId) {
    if (voiceId === 'random_voice') {
      await this.sendMessage(SelectRandomVoice);
    } else {
      await this.sendMessage(SelectVoice(voiceId));
    }
  }

  handleWebsocketMessage = (message) => {
    const parsed = JSON.parse(message.data);
    if (parsed.id || parsed.actionType) {
      let promise = this.promises.find((p) => p.actionId === parsed.id);
      if (promise == null) {
        promise = this.promises.find((p) => p.actionType === parsed.actionType);
      }
      if (promise) {
        if (parsed.payload) {
          promise.resolve(parsed.payload);
        } else if (parsed.actionType) {
          parsed.actionObject
            ? promise.resolve(parsed.actionObject)
            : promise.resolve({});
        }

        this.promises = this.promises.filter(
          (p) => p.actionId !== promise.actionId
        );
      }
    }
  };

  handleWebsocketOpen = () => {
    this.sendMessage(RegisterClient).then(() => {
      this.updateStatus(VOICEMOD_CONNECTED);
    });
  };

  handleWebsocketClose = (e) => {
    if (
      this.status === VOICEMOD_CONNECTED ||
      this.status === VOICEMOD_RECONNECTING
    ) {
      // reconnecting flow
      this.updateStatus(VOICEMOD_RECONNECTING);
      if (this.currentHostIndex + 1 < this.hosts.length) {
        this.currentHostIndex = this.currentHostIndex + 1;
        this.connect();
      } else {
        this.currentHostIndex = 0;
        this.connect();
      }
    }
    if (this.status === VOICEMOD_CONNECTING) {
      //connecting flow
      if (this.currentHostIndex + 1 < this.hosts.length) {
        this.currentHostIndex = this.currentHostIndex + 1;
        this.connect();
      } else {
        this.updateStatus(VOICEMOD_FAILED);
      }
    }
    if (this.status === VOICEMOD_CONNECTED) {
      this.currentHostIndex = 0;
      this.connect();
    }
  };

  sendMessage = (messageBuilder) => {
    let actionId = uuidv4();
    let {message, actionType} = messageBuilder(actionId);
    let promiseResolve, promiseReject;

    let promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    let promiseElement = {
      actionId,
      actionType,
      resolve: promiseResolve,
      reject: promiseReject,
    };
    this.promises.push(promiseElement);

    this.resolve = promiseResolve;
    this.ws.send(JSON.stringify(message));
    return promise;
  };

  disconnect() {
    this.updateStatus(VOICEMOD_DISCONNECTED);
    this.ws.close();
  }

  updateStatus(newStatus) {
    this.status = newStatus;
    if (this.listener != null) {
      this.listener(newStatus);
    }
  }
}

const CreateGetVoiceMessage = (id) => {
  return {
    message: {
      action: 'getVoices',
      id: id,
    },
    actionType: 'getVoices',
  };
};

const GetMemes = (id) => {
  return {
    message: {
      action: 'getMemes',
      id: id,
    },
    actionType: 'getMemes',
  };
};

const RegisterClient = (id) => {
  return {
    message: {
      id: id,
      action: 'registerClient',
      payload: {clientKey: 'pulsoid'},
    },
  };
};

const SelectVoice = (voiceId) => (id) => {
  return {
    message: {
      id,
      payload: {
        voiceID: voiceId,
        voiceId: voiceId,
      },
      action: 'selectVoice',
    },
    actionType: 'selectVoice',
  };
};

const SelectRandomVoice = (id) => {
  return {
    message: {
      id,
      action: 'selectRandomVoice',
    },
    actionType: 'voiceChangerEnabledEvent',
  };
};

const PlayMeme = (fileName) => (id) => {
  return {
    message: {
      action: 'playMeme',
      id: id,
      payload: {
        FileName: fileName,
        IsKeyDown: true,
      },
    },
  };
};

const GetCurrentVoice = (id) => {
  return {
    message: {
      action: 'getCurrentVoice',
      id: id,
      payload: {},
    },
    actionType: 'getCurrentVoice',
  };
};

function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
}

export const VOICEMOD_CONNECTED = 'VOICEMOD_CONNECTED';
export const VOICEMOD_DISCONNECTED = 'VOICEMOD_DISCONNECTED';
export const VOICEMOD_CONNECTING = 'VOICEMOD_CONNECTING';
export const VOICEMOD_RECONNECTING = 'VOICEMOD_RECONNECTING';
export const VOICEMOD_FAILED = 'VOICEMOD_FAILED';
